export const withSymbol: boolean = typeof Symbol !== 'undefined';

export function isNumber(value: unknown): boolean {
	if (typeof value === 'symbol') {
		return false;
	}

	const val = '' + value;

	return !isNaN(parseFloat(val)) && val.replace(/[^\d.]+?/gim, '').length === val.length;
}

export function isScalar(value: unknown): boolean {
	const type = typeof value;

	if (type === 'string') return true;
	if (type === 'number') return true;
	if (type === 'boolean') return true;
	if (withSymbol && type === 'symbol') return true;

	if (value == null) return true;
	if (withSymbol && value instanceof Symbol) return true;
	if (value instanceof String) return true;
	if (value instanceof Number) return true;

	return value instanceof Boolean;
}
